/**
 * Expired Token Page
 *
 * Displayed when a signature/form link has expired.
 */
import { Clock, ArrowLeft } from 'lucide-react';
import { Button, Card, CardContent } from '@respectly/ui';
import { PortalLayout } from '../layouts/PortalLayout';

interface ExpiredPageProps {
  type?: 'document' | 'form';
  expiresAt?: Date | string;
}

export function ExpiredPage({ type = 'document', expiresAt }: ExpiredPageProps) {
  const formattedDate = expiresAt
    ? new Date(expiresAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <PortalLayout>
      <div className="flex flex-1 items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardContent className="p-8 text-center">
            <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-amber-100">
              <Clock className="h-10 w-10 text-amber-600" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900">Link Expired</h1>

            <p className="mt-3 text-gray-600">
              This {type === 'document' ? 'signature request' : 'form link'} has expired
              {formattedDate && ` on ${formattedDate}`}.
            </p>

            <p className="mt-4 text-sm text-gray-500">
              Please contact the sender to request a new link.
            </p>

            <div className="mt-8">
              <Button
                variant="outline"
                className="w-full"
                onClick={() => window.close()}
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Close this page
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </PortalLayout>
  );
}
